module.exports = __webpack_public_path__ + "static/media/InsurancesPartners.f4dc9c8a.png";